import React, { useState } from "react";
import deleteSvg from '../../../../assets/images/service/delete.svg'
import addSvg from '../../../../assets/images/service/add.svg'
interface InputProps {
  value: string;
  onChange?: (value: string, id: string) => void;
  onChangeJob?:(value:string,slotId:string,jobId:string) => void;
  id: string;
  onRemove: (id: string) => void;
  placeholder?: string;
  flag: number
  len: number
  onAdd: any;
  whichOnChange:string
  slotId:string
  jobId:string
}

const Input: React.FC<InputProps> = (props: InputProps) => {
  const { value, onChange, id, onRemove,onChangeJob ,placeholder,flag,len,onAdd,whichOnChange, slotId, jobId } = props;

  

  const handleRemove = () => {
    onRemove(id);
  };
  return (
    
    <div className="flex items-center my-2 md:w-1/2 md:my-0 md:mb-2">
      <div className={`${whichOnChange === "Other" ?"w-full" :"w-11/12"} `}>
        <input
          id={id}
          className="w-full rounded  custom-input-successware pl-3"
          placeholder={placeholder}
          value={value}
          onChange={ whichOnChange === "slot" || whichOnChange === "Other"  ? (e) => onChange?.(e.target.value,e.target.id) : (e) => onChangeJob?.(e.target.value,slotId,jobId)}
          required={whichOnChange === "Other" ? true:false}
          autoComplete="off"
        />
      </div>
      <div className="w-1/7 ml-2 flex align-center">
        { id !== "input1"  ?
          <button type="button" onClick={handleRemove} >
            <img src={deleteSvg} alt=""/>
          </button>:null
        }
        {
          id === "input1" || (len - 1 ) === flag && whichOnChange !== "Other"   ? 
          <button type="button" onClick={onAdd} >
            <img src={addSvg} alt="" className="custom-btn-add-service-width"/>
          </button> : null
        }

      </div>
    </div>
  );
};

export default Input;
